import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import TornadoArchiveApp from './App';
import reportWebVitals from './reportWebVitals';

import default_days_na from './json/default-dates-na.json';
import default_days_eu from './json/default-dates-eu.json';
import {randomChoice} from './utils.js';

import { DateTime } from 'luxon';

const default_domain = 'North America'
const default_days_map = {
    'Europe': default_days_eu,
    'North America': default_days_na
}

const cdays = default_days_map[default_domain].map(dt => DateTime.fromISO(dt, {'zone': 'utc'}));

ReactDOM.render(
  <React.StrictMode>
    <TornadoArchiveApp
        default_domain={default_domain}
        default_day={randomChoice(cdays)}
    />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
